var map = {
	"./activities-search/WidgetActivitiesSearch.type.tsx": 66780,
	"./activity-viewer/WidgetActivityViewer.type.tsx": 31964,
	"./assignment-models/WidgetAssignmentModels.type.tsx": 38953,
	"./assignment-viewer/WidgetAssignmentViewer.type.tsx": 98780,
	"./assignments/WidgetAssignments.type.tsx": 40631,
	"./bookmarks/WidgetBookmarks.type.tsx": 16638,
	"./dam-geolocation/WidgetDamGeolocation.type.tsx": 61321,
	"./dam-georegistry/WidgetDamGeoregistryViewer.type.tsx": 1664,
	"./dam-monitoring/WidgetDamMonitoring.type.tsx": 97804,
	"./dams-monitoring-multiple/WidgetMultipleDamsMonitoring.type.tsx": 2984,
	"./dams-search/WidgetDamsSearch.type.tsx": 34205,
	"./document-protocol-queue/WidgetDocumentSendToProtocolQueue.type.tsx": 63247,
	"./document-protocol/WidgetDocumentProtocol.type.tsx": 8503,
	"./document-sign/WidgetDocumentSign.type.tsx": 79594,
	"./document-viewer/WidgetDocumentViewer.type.tsx": 64621,
	"./documents-search/WidgetDocumentsSearch.type.tsx": 21502,
	"./dossier-create/WidgetDossierCreate.type.tsx": 81682,
	"./dossier-viewer/WidgetDossierViewer.type.tsx": 57805,
	"./dossiers-search/WidgetDossiersSearch.type.tsx": 59775,
	"./full-text-documents-search/WidgetFullTextDocumentsSearch.type.tsx": 465,
	"./highlighted-assignments/WidgetHighlightedAssignments.type.tsx": 28761,
	"./highlighted-documents/WidgetHighlightedDocuments.type.tsx": 2195,
	"./highlighted-dossiers/WidgetHighlightedDossiers.type.tsx": 26443,
	"./mail-protocol-assignment/WidgetMailProtocolAssignment.type.tsx": 75962,
	"./mail-viewer/WidgetMailViewer.type.tsx": 37426,
	"./mails/WidgetMails.type.tsx": 94797,
	"./monitor-assignments/WidgetMonitorAssignments.type.tsx": 48125,
	"./monitor-office-assignments/WidgetMonitorOfficeAssignments.type.tsx": 82621,
	"./monitor-sent-assignments/WidgetMonitorSentAssignments.type.tsx": 36673,
	"./organization-chart/WidgetOrganizzationChart.type.tsx": 47304,
	"./personal-dossier/WidgetPersonalDossier.type.tsx": 39674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79450;